import React from 'react';
import { motion } from 'framer-motion';
interface JarVisualProps {
  color: 'spend' | 'save' | 'give';
  label: string;
  fillPercent?: number;
  size?: 'sm' | 'md' | 'lg';
  animate?: boolean;
}
const colorMap = {
  spend: {
    fill: '#2D8B57',
    lid: '#236B44',
    glow: 'rgba(45, 139, 87, 0.3)'
  },
  save: {
    fill: '#2B6CB0',
    lid: '#1E5290',
    glow: 'rgba(43, 108, 176, 0.3)'
  },
  give: {
    fill: '#C75B3A',
    lid: '#A04A2E',
    glow: 'rgba(199, 91, 58, 0.3)'
  }
};
const sizeMap = {
  sm: {
    width: 48,
    height: 64
  },
  md: {
    width: 72,
    height: 96
  },
  lg: {
    width: 96,
    height: 128
  }
};
export function JarVisual({
  color,
  label,
  fillPercent = 70,
  size = 'md',
  animate = true
}: JarVisualProps) {
  const colors = colorMap[color];
  const dimensions = sizeMap[size];
  return <div className="flex flex-col items-center gap-2" role="img" aria-label={`Jarra de ${label}`} data-id="element-54">
      <div style={{
      filter: `drop-shadow(0 0 8px ${colors.glow})`
    }} data-id="element-55">
        <svg width={dimensions.width} height={dimensions.height} viewBox="0 0 72 96" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-56">
          <rect x="20" y="2" width="32" height="6" rx="2" fill={colors.lid} data-id="element-57" />
          <rect x="18" y="7" width="36" height="4" rx="1" fill={colors.lid} opacity="0.8" data-id="element-58" />
          <path d="M18 11 C18 11, 14 16, 14 22 L14 82 C14 88, 18 92, 24 92 L48 92 C54 92, 58 88, 58 82 L58 22 C58 16, 54 11, 54 11 Z" fill="rgba(255,255,255,0.15)" stroke={colors.fill} strokeWidth="2" data-id="element-59" />
          <clipPath id={`jar-clip-${color}-${label}`} data-id="element-60">
            <path d="M16 14 C16 14, 14 18, 14 22 L14 82 C14 88, 18 92, 24 92 L48 92 C54 92, 58 88, 58 82 L58 22 C58 18, 56 14, 56 14 Z" data-id="element-61" />
          </clipPath>
          <motion.rect x="14" y={92 - fillPercent / 100 * 72} width="44" height={fillPercent / 100 * 72} fill={colors.fill} opacity="0.45" clipPath={`url(#jar-clip-${color}-${label})`} initial={animate ? {
          height: 0,
          y: 92
        } : undefined} whileInView={animate ? {
          height: fillPercent / 100 * 72,
          y: 92 - fillPercent / 100 * 72
        } : undefined} transition={{
          duration: 1.2,
          ease: [0.4, 0, 0.2, 1],
          delay: 0.2
        }} viewport={{
          once: true
        }} data-id="element-62" />
          <motion.ellipse cx="36" cy={92 - fillPercent / 100 * 72} rx="20" ry="2.5" fill={colors.fill} opacity="0.5" clipPath={`url(#jar-clip-${color}-${label})`} initial={animate ? {
          cy: 92,
          opacity: 0
        } : undefined} whileInView={animate ? {
          cy: 92 - fillPercent / 100 * 72,
          opacity: 0.5
        } : undefined} transition={{
          duration: 1.2,
          ease: [0.4, 0, 0.2, 1],
          delay: 0.2
        }} viewport={{
          once: true
        }} data-id="element-63" />
          <rect x="22" y="18" width="3" height="40" rx="1.5" fill="white" opacity="0.15" data-id="element-64" />
        </svg>
      </div>
    </div>;
}